import { render } from "./TonnageBoard.vue?vue&type=template&id=019ed020"
import script from "./TonnageBoard.vue?vue&type=script&lang=js"
export * from "./TonnageBoard.vue?vue&type=script&lang=js"

import "./TonnageBoard.vue?vue&type=style&index=0&id=019ed020&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__